export const calcInsideBorder = (params: {
    width: number,
    percPhone: number,
}) => 0.045 * params.width * params.percPhone;
export const calcOutsideBorder = (params: {
    width: number,
    percPhone: number,
}) => 0.015 * params.width * params.percPhone;

interface Props {
    percMultiplier: number,
    percPhone: number,
    width: number,
    height: number,
    children: React.ReactNode,
}

const PhoneApp: React.FC<Props> = ({
    percPhone, width, height, children,
}) => {
    const insideBorderRadius = 0.1 * width * percPhone;
    const outsideBorderRadius = 0.12 * width * percPhone;
    const insideBorder = calcInsideBorder({ width, percPhone });
    const outsideBorder = calcOutsideBorder({ width, percPhone });

    return (
        <div style={{
            border: `${outsideBorder}px solid grey`,
            borderRadius: outsideBorderRadius,
            backgroundColor: 'white',
            width: 'min-content',
            height: 'min-content',
            overflow: 'hidden',
        }}
        >
            <div style={{
                borderRadius: insideBorderRadius,
                border: `${insideBorder}px solid black`,
                overflow: 'hidden',
                width: width - 2 * (outsideBorder + insideBorder),
                height: height - 2 * (outsideBorder + insideBorder),
            }}
            >{children}
            </div>
        </div>
    );
};

export default PhoneApp;
